import { lazy, Suspense } from "react";
import {
  BrowserRouter,
  Navigate,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import HomePage from "./pages/Home/HomePage";
import WhatsAppButton from "./components/WhatsAppButton";
import CookieBanner from "./components/CookieBanner";
import ScrollToTop from "./components/ScrollToTop";

const ImanesLanding = lazy(() =>
  import("./pages/ImanesLanding/ImanesLanding"),
);
const FramesLanding = lazy(() =>
  import("./pages/FramesLanding/FramesLanding"),
);
const PhotoUploadPageV2 = lazy(() =>
  import("./pages/PhotoUpload/PhotoUploadPageV2"),
);
const CollageEditor = lazy(() =>
  import("./pages/CollageEditor/CollageEditor"),
);
const FramesEditor = lazy(() =>
  import("./pages/FramesEditor/FramesEditor"),
);
const MarcoDuo = lazy(() => import("./pages/MarcoDuo/MarcoDuo"));
const MarcoMosaico = lazy(() =>
  import("./pages/MarcoMosaico/MarcoMosaico"),
);
const MarcoSecuencia = lazy(() =>
  import("./pages/MarcoSecuencia/MarcoSecuencia"),
);
const ProductPage = lazy(() =>
  import("./pages/ProductPage/ProductPage"),
);
const ShopPage = lazy(() => import("./pages/Shop/ShopPage"));
const CartPage = lazy(() => import("./pages/Cart/CartPage"));
const SuccessPage = lazy(() => import("./pages/Checkout/SuccessPage"));
const CancelPage = lazy(() => import("./pages/Checkout/CancelPage"));
const TermsPage = lazy(() => import("./pages/legal/TermsPage"));
const PrivacyPage = lazy(() => import("./pages/legal/PrivacyPage"));
const RefundsPage = lazy(() => import("./pages/legal/RefundsPage"));
const LegalNoticePage = lazy(() =>
  import("./pages/legal/LegalNoticePage"),
);
const ContactPage = lazy(() => import("./pages/Contact/ContactPage"));
const HelpPage = lazy(() => import("./pages/HelpPage/HelpPage"));
const OffersPage = lazy(() => import("./pages/Offers/OffersPage"));
const CampaignOfferEditor = lazy(() =>
  import("./pages/CampaignOfferEditor/CampaignOfferEditor"),
);
const CampaignAdminPage = lazy(() =>
  import("./pages/CampaignAdmin/CampaignAdminPage"),
);
const NotFoundPage = lazy(() => import("./pages/NotFound/NotFoundPage"));

function AppContent() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <>
      <ScrollToTop />

      <Suspense
        fallback={
          <div className="route-loading" role="status" aria-live="polite">
            Cargando contenido…
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/producto/:slug" element={<ProductPage />} />
          <Route path="/tienda" element={<ShopPage />} />
          <Route path="/carrito" element={<CartPage />} />
          <Route
            path="/collage-magnetico-personalizado"
            element={<CollageEditor />}
          />
          <Route
            path="/editor"
            element={
              <Navigate to="/collage-magnetico-personalizado" replace />
            }
          />
          <Route
            path="/imanes-personalizados-con-fotos"
            element={<ImanesLanding />}
          />
          <Route
            path="/marcos-para-imanes-personalizados"
            element={<FramesLanding />}
          />
          <Route path="/fotos" element={<PhotoUploadPageV2 />} />
          <Route
            path="/marcos"
            element={
              <Navigate to="/marcos-para-imanes-personalizados" replace />
            }
          />
          <Route path="/marcos-individuales" element={<FramesEditor />} />
          <Route path="/marco-duo" element={<MarcoDuo />} />
          <Route path="/marco-mosaico" element={<MarcoMosaico />} />
          <Route path="/marco-secuencia" element={<MarcoSecuencia />} />
          <Route path="/terminos" element={<TermsPage />} />
          <Route path="/privacidad" element={<PrivacyPage />} />
          <Route path="/devoluciones" element={<RefundsPage />} />
          <Route path="/aviso-legal" element={<LegalNoticePage />} />
          <Route path="/contacto" element={<ContactPage />} />
          <Route path="/ayuda" element={<HelpPage />} />
          <Route path="/ofertas" element={<OffersPage />} />
          <Route path="/oferta/:productId" element={<CampaignOfferEditor />} />
          <Route path="/admin" element={<CampaignAdminPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/cancel" element={<CancelPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>

      {!isAdmin && <WhatsAppButton />}
      {!isAdmin && <CookieBanner />}
    </>
  );
}

export default function AppRouter() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
